type Props = {
  label: string;
  value: string;
  unit?: string;
  hint?: string;
};

export default function KPICard({ label, value, unit, hint }: Props) {
  return (
    <div className="kpi">
      <div className="kpi__label">{label}</div>
      <div className="kpi__value">
        <span className="kpi__number">{value}</span>
        {unit && <span className="kpi__unit">{unit}</span>}
      </div>
      {hint && <div className="kpi__hint">{hint}</div>}
    </div>
  );
}
